import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Employers } from '../types';

import { schema } from '../utils/schema';

import { EMPLOYERS } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import { ControlledTextField } from 'components/shared';
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export default function CreateEditEmployersForm({
  rowId,
  handleClose,
  rowData
}: FormComponentProps<Employers>) {
  const { t } = useTranslation('common');
  const { mutateAsync: save, isLoading } = useSaveResource({
    url: EMPLOYERS,
    id: rowId,
    invalidateQueryKey: ['employers', 'list']
  });

  const methods = useForm<Employers>({
    defaultValues: schema.cast(rowData ?? undefined),
    resolver: yupResolver(schema)
  });

  const { control, handleSubmit } = methods;

  const onSubmit = (payload: Employers) => {
    save(payload).then(handleClose);
  };

  return (
    <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <MultiStepForm.Section
        title={t('employers.formSectionLabels.basis')}
        validateFields={['name', 'nameBrief']}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ControlledTextField
              control={control}
              variant="outlined"
              label={t('employers.grid.name')}
              name="name"
            />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField
              control={control}
              variant="outlined"
              label={t('employers.grid.nameBrief')}
              name="nameBrief"
            />
          </Grid>
        </Grid>
      </MultiStepForm.Section>

      <MultiStepForm.Actions>
        <Box display="flex" ml="auto">
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            autoFocus
            color="dark"
          >
            {!rowData?.employerId ? t('save') : t('edit')}
          </LoadingButton>
        </Box>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
}
